export function setDocumentTitle(title) {
  if (typeof document === "undefined") return;
  if (title) document.title = title;
}

function upsertMeta({ selector, createAttrs, setAttrs }) {
  if (typeof document === "undefined") return;

  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    for (const [key, value] of Object.entries(createAttrs)) {
      element.setAttribute(key, value);
    }
    document.head.appendChild(element);
  }

  for (const [key, value] of Object.entries(setAttrs)) {
    element.setAttribute(key, value);
  }
}

export function setMetaDescription(description) {
  if (!description) return;
  upsertMeta({
    selector: 'meta[name="description"]',
    createAttrs: { name: "description" },
    setAttrs: { content: description },
  });
}

export function setOpenGraph({ title, description, url, image, type = "website" }) {
  if (title) {
    upsertMeta({
      selector: 'meta[property="og:title"]',
      createAttrs: { property: "og:title" },
      setAttrs: { content: title },
    });
  }

  if (description) {
    upsertMeta({
      selector: 'meta[property="og:description"]',
      createAttrs: { property: "og:description" },
      setAttrs: { content: description },
    });
  }

  if (url) {
    upsertMeta({
      selector: 'meta[property="og:url"]',
      createAttrs: { property: "og:url" },
      setAttrs: { content: url },
    });
  }

  if (image) {
    upsertMeta({
      selector: 'meta[property="og:image"]',
      createAttrs: { property: "og:image" },
      setAttrs: { content: image },
    });
  }

  if (type) {
    upsertMeta({
      selector: 'meta[property="og:type"]',
      createAttrs: { property: "og:type" },
      setAttrs: { content: type },
    });
  }
}

export function setTwitterCard({ title, description, card = "summary_large_image" }) {
  upsertMeta({
    selector: 'meta[name="twitter:card"]',
    createAttrs: { name: "twitter:card" },
    setAttrs: { content: card },
  });

  if (title) {
    upsertMeta({
      selector: 'meta[name="twitter:title"]',
      createAttrs: { name: "twitter:title" },
      setAttrs: { content: title },
    });
  }

  if (description) {
    upsertMeta({
      selector: 'meta[name="twitter:description"]',
      createAttrs: { name: "twitter:description" },
      setAttrs: { content: description },
    });
  }
}

export function setCanonicalUrl(url) {
  if (typeof document === "undefined") return;
  if (!url) return;

  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

const PRODUCTION_ORIGIN = "https://www.knooth.com";

export function absoluteUrl(pathname) {
  const path = pathname?.startsWith("/") ? pathname : `/${pathname || ""}`;
  if (typeof window === "undefined") return `${PRODUCTION_ORIGIN}${path}`;

  const origin = window.location.origin;
  // Use production origin in builds; dev origin otherwise
  const base =
    origin.includes("localhost") || origin.includes("127.0.0.1")
      ? PRODUCTION_ORIGIN
      : origin.endsWith("/")
        ? origin.slice(0, -1)
        : origin;
  return `${base}${path}`;
}
